import { forwardRef, type Ref, type SVGProps } from "react";
const IconMedicalFacilityOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 4a1 1 0 0 1 1-1h2.4a1 1 0 0 1 0 2H5.03c.102 1.867.479 4.428 1.23 6.641.448 1.323 1.008 2.45 1.667 3.23C8.575 15.637 9.257 16 10 16c.744 0 1.425-.363 2.073-1.129.66-.78 1.219-1.907 1.668-3.23.75-2.213 1.127-4.774 1.23-6.641H13.6a1 1 0 1 1 0-2H16a1 1 0 0 1 1 1c0 2.04-.387 5.4-1.366 8.284-.488 1.44-1.147 2.83-2.035 3.88-.689.814-1.552 1.459-2.596 1.716.014 1.398.086 3.073.463 4.487.23.859.548 1.528.956 1.97.378.41.864.663 1.578.663.46 0 .948-.294 1.52-1.237.563-.93 1.03-2.2 1.54-3.605l.022-.06c.484-1.33 1.011-2.782 1.688-3.898.678-1.12 1.69-2.2 3.23-2.2 1.23 0 2.226.393 2.988 1.091.74.678 1.187 1.579 1.468 2.49.45 1.464.528 3.17.541 4.544A4.002 4.002 0 0 1 26 30a4 4 0 0 1-1.003-7.873c-.015-1.326-.087-2.77-.453-3.958q-.329-1.072-.907-1.604C23.274 16.232 22.77 16 22 16c-.46 0-.948.294-1.52 1.237-.563.93-1.03 2.2-1.54 3.605l-.022.06c-.484 1.33-1.011 2.782-1.688 3.898-.678 1.12-1.69 2.2-3.23 2.2-1.286 0-2.3-.497-3.047-1.306-.717-.776-1.148-1.795-1.42-2.811-.441-1.658-.517-3.558-.53-5.002-1.047-.256-1.912-.902-2.602-1.718-.888-1.049-1.547-2.44-2.035-3.88C3.387 9.4 3 6.04 3 4m25 22a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMedicalFacilityOutlineSVG);
ForwardRef.displayName = "IconMedicalFacilityOutline";
export { ForwardRef as IconMedicalFacilityOutline };
